import '../styles/contact-styles.css'

function LoadContact() {

    return (
        <div className="container" id="contact">
            <div>
                <h2>The Possibilities are Endless.</h2>
                <p>Have a complex challenge? An ambitious idea? Or a process ready for intelligent automation? We should talk. Let's explore how a strategic partnership and co-developed IP can create lasting value for your organization.</p>
            </div>

            <div className='contact-section'>
                <button onClick={() => {window.location.href = "mailto:contact@hyperworksimaging.com";}}>Start a conversation</button>
                <p>Or email us at <a href="mailto:contact@hyperworksimaging.com">contact@hyperworksimaging.com</a></p>
            </div>
        </div>
    )
}

export default LoadContact;